export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Mollie"] = "Mollie";
    PaymentProvider["Payconiq"] = "Payconiq";
    PaymentProvider["Buckaroo"] = "Buckaroo";
    PaymentProvider["Stripe"] = "Stripe";
})(PaymentProvider || (PaymentProvider = {}));
export function getPaymentProviderName(type) {
    if (type === PaymentProvider.Payconiq) {
        return $t(`%1cA`);
    }
    return type.toString();
}
//# sourceMappingURL=PaymentProvider.js.map